export default __webpack_public_path__ + "0bf640e3ab1c903542ede975ad7b928b.png";